module.exports = "<div class=component-wx-control> <div class=wx-control-render> </div> <div class=bottom-submit> {{#if submit}} <button class=submit>确定</button> <button class=cancel>取消</button> {{else}} <button class=cancel>取消</button> {{/if}} </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./app/components/form/WXbase-control/WXbase-control.html
// module id = 1924
// module chunks = 50